import axios from '@/api/axiosInstance';

export default async function getActivities({ themeId, type, exclude }) {
  const response = await axios({
    method: 'get',
    url: `${process.env.API || process.env.NEXT_PUBLIC_API}/activities`,
    params: {
      themeId,
      type,
      exclude,
    },
  });

  return response.data;
}
